import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import DuoWorkModeItem from "./DuoWorkModeItem/DuoWorkModeItem";
import DuoWorkModeList from "./DuoWorkModeList/DuoWorkModeList";
import { BaseRouteWithHeaderWrapper } from "../../../../components/RouteWithHeaderWrapper/RouteWithHeaderWrapper";
import { pageTitles } from "../../../../utils/messages";

const TeacherDuoWorkMode = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                <BaseRouteWithHeaderWrapper
                    title={pageTitles.teacherDuosListTitle}
                >
                    <DuoWorkModeList />
                </BaseRouteWithHeaderWrapper>
            </Route>
            <Route path={`${path}/:resourceId`}>
                <DuoWorkModeItem />
            </Route>
        </Switch>
    );
};

export default TeacherDuoWorkMode;
